import { PlatformActionTypes } from 'src/actions/platformActions';

export interface PlatformState {
  shortDateFormat: string;
  hideUserAddress: boolean;
}

const initialState: PlatformState = {
  shortDateFormat: 'DD/MM',
  hideUserAddress: false,
};

export function platformReducer(
  state = initialState,
  action: PlatformActionTypes
): PlatformState {
  switch (action.type) {
    default:
      return state;
  }
}
